import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import symbol from "../../assets/images/logo-symbol.png";
import logoWoSymbol from "../../assets/images/logo-wo-symbol.png";
import {
  FaBolt,
  FaCircleChevronLeft,
  FaCircleChevronRight,
} from "react-icons/fa6";
import { FaBars, FaFire } from "react-icons/fa6";
import { AiOutlineAudit } from "react-icons/ai";
import { GoVerified, GoRocket, GoCodescanCheckmark } from "react-icons/go";
import { LiaFileContractSolid } from "react-icons/lia";
import { LuUserCheck } from "react-icons/lu";
import { FaEthereum } from "react-icons/fa";
import { TbCurrencySolana, TbBrandBinance } from "react-icons/tb";
import { CiCircleMore } from "react-icons/ci";
const Aside = ({
  isWideScreen,
  isHovered,
  handleMouseEnter,
  handleMouseLeave,
  handleAside,
}) => {
  return (
    <div
      className={`hidden sm:block ${
        isWideScreen ? "xl:w-[192px] w-16 transition-width" : ""
      }`}
    >
      <div
        className={`${
          isWideScreen ? "xl:w-[192px]" : ""
        } w-16 transition-width`}
      >
        <div
          className={`group fixed bottom-0 left-0 top-0 z-fixed h-screen border-r border-neutral-90 bg-black-100 dark:bg-neutral-100 w-16 transition-width ${
            isWideScreen ? "xl:w-[192px]" : ""
          } hover:w-[192px]`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div className="h-full overflow-x-hidden">
            <div className="flex h-full flex-col gap-1 pb-6 pt-8">
              <div
                className={`mb-3 flex justify-center gap-1 opacity-100 xl:opacity-100 `}
              >
                {isHovered || isWideScreen ? (
                  <>
                    <a href="/" target="_blank" rel="noreferrer">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        className="text-neutral-50 transition-colors hover:text-neutral-0"
                      >
                        <rect width="24" height="24" fill="none"></rect>
                        <path
                          d="M17.2165 3.86475H19.9766L13.9466 10.7567L21.0405 20.1351H15.486L11.1356 14.4471L6.1577 20.1351H3.39591L9.84564 12.7634L3.04047 3.86475H8.73592L12.6683 9.06375L17.2165 3.86475ZM16.2478 18.483H17.7772L7.90488 5.43004H6.26366L16.2478 18.483Z"
                          fill="currentColor"
                        ></path>
                      </svg>
                      <span className="sr-only">Twitter</span>
                    </a>
                    <a href="/" target="_blank" rel="noreferrer">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        className="text-neutral-50 transition-colors hover:text-neutral-0"
                      >
                        <rect width="24" height="24" fill="none"></rect>
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M22 12C22 17.5228 17.5228 22 12 22C6.47716 22 2 17.5228 2 12C2 6.47716 6.47716 2 12 2C17.5228 2 22 6.47716 22 12ZM12.8964 9.13874C11.1623 9.8613 6.16234 11.9133 6.16234 11.9133C4.97738 12.3757 5.67098 12.8093 5.67098 12.8093C5.67098 12.8093 6.68254 13.1561 7.54962 13.4162C8.41666 13.6763 8.8791 13.3873 8.8791 13.3873C8.8791 13.3873 10.9022 12.0578 12.9542 10.6416C14.3993 9.65898 14.0525 10.4682 13.7057 10.8151C12.9542 11.5665 11.7115 12.7515 10.671 13.7052C10.2086 14.1099 10.4398 14.4567 10.6421 14.6301C11.2305 15.1279 12.6163 16.0334 13.2455 16.4445C13.4198 16.5584 13.5361 16.6344 13.5612 16.6532C13.7057 16.7688 14.5149 17.289 15.0063 17.1734C15.4976 17.0578 15.5554 16.3931 15.5554 16.3931C15.5554 16.3931 15.9311 14.0231 16.2779 11.8555C16.3422 11.4299 16.4064 11.0132 16.4663 10.6247C16.622 9.61486 16.7484 8.79512 16.7693 8.5029C16.856 7.52026 15.8155 7.92486 15.8155 7.92486C15.8155 7.92486 13.5612 8.84974 12.8964 9.13874Z"
                          fill="currentColor"
                        ></path>
                      </svg>
                      <span className="sr-only">Telegram</span>
                    </a>
                  </>
                ) : (
                  <FaBars className="text-xl text-neutral-0" />
                )}
              </div>

              <nav className="relative flex min-h-0 flex-col gap-4 overflow-y-auto overscroll-contain scrollbar-hide">
                <div className="flex flex-col gap-0.5">
                  <Link
                    to="/"
                    className={`block w-full border-transparent py-2 transition-all xl:border-primary-main bg-neutral-0/10 font-medium text-neutral-0 group-hover:border-primary-main cursor-pointer`}
                  >
                    <div className="flex flex-row items-center gap-3 transition-[margin] ml-[1-5rem] group-hover:ml-[1.5rem] xl:ml-[1.125rem]">
                      <div className="flex items-center gap-2">
                        <FaBolt />
                        <div
                          className={`whitespace-nowrap text-sm opacity-0 transition   ${
                            isHovered || isWideScreen
                              ? "opacity-100 xl:opacity-100"
                              : ""
                          }`}
                        >
                          Dashboard
                        </div>
                      </div>
                    </div>
                  </Link>
                  <Link
                    to="/"
                    className={`block w-full border-transparent py-2 transition-all  font-normal text-neutral-30 cursor-pointer hover:bg-neutral-0/10`}
                  >
                    <div className="flex flex-row items-center gap-3 transition-[margin] ml-[1-5rem] group-hover:ml-[1.5rem] xl:ml-[1.125rem]">
                      <div className="flex items-center gap-2">
                        <GoRocket />
                        <div
                          className={`whitespace-nowrap text-sm opacity-0 transition   ${
                            isHovered || isWideScreen
                              ? "opacity-100 xl:opacity-100"
                              : ""
                          }`}
                        >
                          Projects
                        </div>
                      </div>
                    </div>
                  </Link>
                  <Link
                    to="/"
                    className={`block w-full border-transparent py-2 transition-all  font-normal text-neutral-30 cursor-pointer hover:bg-neutral-0/10`}
                  >
                    <div className="flex flex-row items-center gap-3 transition-[margin] ml-[1-5rem] group-hover:ml-[1.5rem] xl:ml-[1.125rem]">
                      <div className="flex items-center gap-2">
                        <FaFire />
                        <div
                          className={`whitespace-nowrap text-sm opacity-0 transition   ${
                            isHovered || isWideScreen
                              ? "opacity-100 xl:opacity-100"
                              : ""
                          }`}
                        >
                          PreLaunch
                        </div>
                      </div>
                    </div>
                  </Link>
                  <Link
                    to="/"
                    className={`block w-full border-transparent py-2 transition-all  font-normal text-neutral-30 cursor-pointer hover:bg-neutral-0/10`}
                  >
                    <div className="flex flex-row items-center gap-3 transition-[margin] ml-[1-5rem] group-hover:ml-[1.5rem] xl:ml-[1.125rem]">
                      <div className="flex items-center gap-2">
                        <LuUserCheck />
                        <div
                          className={`whitespace-nowrap text-sm opacity-0 transition   ${
                            isHovered || isWideScreen
                              ? "opacity-100 xl:opacity-100"
                              : ""
                          }`}
                        >
                          KYC Projects
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="flex flex-col gap-1">
                  <div className="flex items-center relative w-full px-5 py-1 group-hover:pl-6 group-hover:pr-4 transition-[padding] xl:pl-6 xl:pr-4">
                    <div
                      className={`opacity-0 group-hover:opacity-100 flex w-0 items-center justify-center group-hover:w-full transition transition-[width] xl:w-full xl:opacity-100 ${
                        isHovered || isWideScreen ? "opacity-100" : ""
                      }`}
                    >
                      <div className="truncate text-xs font-medium text-neutral-0">
                        Ecosystem
                      </div>
                    </div>
                    <div className="grow h-px bg-neutral-80 opacity-100 group-hover:opacity-0 transition-opacity xl:opacity-0"></div>
                  </div>
                  <div className="flex flex-col gap-0.5">
                    <Link
                      to="/"
                      className={`block w-full ${
                        isHovered || isWideScreen ? "border-r-2" : "border-r-0"
                      } border-transparent py-2 transition-all  font-normal text-neutral-30 cursor-pointer hover:bg-neutral-0/10`}
                    >
                      <div className="flex flex-row items-center gap-3 transition-[margin] ml-[1-5rem] group-hover:ml-[1.5rem] xl:ml-[1.125rem]">
                        <div className="flex items-center gap-2">
                          <TbBrandBinance />
                          <div
                            className={`whitespace-nowrap text-sm opacity-0 transition   ${
                              isHovered || isWideScreen
                                ? "opacity-100 xl:opacity-100"
                                : ""
                            }`}
                          >
                            BSC
                          </div>
                        </div>
                      </div>
                    </Link>
                    <Link
                      to="/"
                      className={`block w-full ${
                        isHovered || isWideScreen ? "border-r-2" : "border-r-0"
                      } border-transparent py-2 transition-all  font-normal text-neutral-30 cursor-pointer hover:bg-neutral-0/10`}
                    >
                      <div className="flex flex-row items-center gap-3 transition-[margin] ml-[1-5rem] group-hover:ml-[1.5rem] xl:ml-[1.125rem]">
                        <div className="flex items-center gap-2">
                          <FaEthereum />
                          <div
                            className={`whitespace-nowrap text-sm opacity-0 transition   ${
                              isHovered || isWideScreen
                                ? "opacity-100 xl:opacity-100"
                                : ""
                            }`}
                          >
                            Ethereum
                          </div>
                        </div>
                      </div>
                    </Link>
                    <Link
                      to="/"
                      className={`block w-full ${
                        isHovered || isWideScreen ? "border-r-2" : "border-r-0"
                      } border-transparent py-2 transition-all  font-normal text-neutral-30 cursor-pointer hover:bg-neutral-0/10`}
                    >
                      <div className="flex flex-row items-center gap-3 transition-[margin] ml-[1-5rem] group-hover:ml-[1.5rem] xl:ml-[1.125rem]">
                        <div className="flex items-center gap-2">
                          <TbCurrencySolana />
                          <div
                            className={`whitespace-nowrap text-sm opacity-0 transition   ${
                              isHovered || isWideScreen
                                ? "opacity-100 xl:opacity-100"
                                : ""
                            }`}
                          >
                            Solana
                          </div>
                          <div className="whitespace-nowrap opacity-0 transition group-hover:opacity-100 xl:opacity-100">
                            <div className="flex items-center gap-1 truncate rounded px-1 py-0.5 font-semibold capitalize text-2xs text-neutral-100 bg-neutral-30">
                              NEW
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                    <Link
                      to="/"
                      className={`block w-full ${
                        isHovered || isWideScreen ? "border-r-2" : "border-r-0"
                      } border-transparent py-2 transition-all  font-normal text-neutral-30 cursor-pointer hover:bg-neutral-0/10`}
                    >
                      <div className="flex flex-row items-center gap-3 transition-[margin] ml-[1-5rem] group-hover:ml-[1.5rem] xl:ml-[1.125rem]">
                        <div className="flex items-center gap-2">
                          <CiCircleMore />
                          <div
                            className={`whitespace-nowrap text-sm opacity-0 transition   ${
                              isHovered || isWideScreen
                                ? "opacity-100 xl:opacity-100"
                                : ""
                            }`}
                          >
                            Other
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="flex flex-col gap-1">
                  <div className="flex items-center relative w-full px-5 py-1 group-hover:pl-6 group-hover:pr-4 transition-[padding] xl:pl-6 xl:pr-4">
                    <div
                      className={`opacity-0 group-hover:opacity-100 flex w-0 items-center justify-center group-hover:w-full transition transition-[width] xl:w-full xl:opacity-100 ${
                        isHovered || isWideScreen ? "opacity-100" : ""
                      }`}
                    >
                      <div className="truncate text-xs font-medium text-neutral-0">
                        Services
                      </div>
                    </div>
                    <div className="grow h-px bg-neutral-80 opacity-100 group-hover:opacity-0 transition-opacity xl:opacity-0"></div>
                  </div>
                  <div className="flex flex-col gap-0.5">
                    <Link
                      to="/"
                      className={`block w-full ${
                        isHovered || isWideScreen ? "border-r-2" : "border-r-0"
                      } border-transparent py-2 transition-all  font-normal text-neutral-30 cursor-pointer hover:bg-neutral-0/10`}
                    >
                      <div className="flex flex-row items-center gap-3 transition-[margin] ml-[1-5rem] group-hover:ml-[1.5rem] xl:ml-[1.125rem]">
                        <div className="flex items-center gap-2">
                          <AiOutlineAudit />
                          <div
                            className={`whitespace-nowrap text-sm opacity-0 transition   ${
                              isHovered || isWideScreen
                                ? "opacity-100 xl:opacity-100"
                                : ""
                            }`}
                          >
                            Audits
                          </div>
                        </div>
                      </div>
                    </Link>
                    <Link
                      to="/"
                      className={`block w-full ${
                        isHovered || isWideScreen ? "border-r-2" : "border-r-0"
                      } border-transparent py-2 transition-all  font-normal text-neutral-30 cursor-pointer hover:bg-neutral-0/10`}
                    >
                      <div className="flex flex-row items-center gap-3 transition-[margin] ml-[1-5rem] group-hover:ml-[1.5rem] xl:ml-[1.125rem]">
                        <div className="flex items-center gap-2">
                          <GoVerified />
                          <div
                            className={`whitespace-nowrap text-sm opacity-0 transition   ${
                              isHovered || isWideScreen
                                ? "opacity-100 xl:opacity-100"
                                : ""
                            }`}
                          >
                            KYC
                          </div>
                        </div>
                      </div>
                    </Link>
                    <Link
                      to="/"
                      className={`block w-full ${
                        isHovered || isWideScreen ? "border-r-2" : "border-r-0"
                      } border-transparent py-2 transition-all  font-normal text-neutral-30 cursor-pointer hover:bg-neutral-0/10`}
                    >
                      <div className="flex flex-row items-center gap-3 transition-[margin] ml-[1-5rem] group-hover:ml-[1.5rem] xl:ml-[1.125rem]">
                        <div className="flex items-center gap-2">
                          <LiaFileContractSolid />
                          <div
                            className={`whitespace-nowrap text-sm opacity-0 transition   ${
                              isHovered || isWideScreen
                                ? "opacity-100 xl:opacity-100"
                                : ""
                            }`}
                          >
                            Smart Contracts
                          </div>
                        </div>
                      </div>
                    </Link>
                    <Link
                      to="/"
                      className={`block w-full ${
                        isHovered || isWideScreen ? "border-r-2" : "border-r-0"
                      } border-transparent py-2 transition-all  font-normal text-neutral-30 cursor-pointer hover:bg-neutral-0/10`}
                    >
                      <div className="flex flex-row items-center gap-3 transition-[margin] ml-[1-5rem] group-hover:ml-[1.5rem] xl:ml-[1.125rem]">
                        <div className="flex items-center gap-2">
                          <GoCodescanCheckmark />
                          <div
                            className={`whitespace-nowrap text-sm opacity-0 transition   ${
                              isHovered || isWideScreen
                                ? "opacity-100 xl:opacity-100"
                                : ""
                            }`}
                          >
                            Formal Verification
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </nav>
              {isHovered || isWideScreen ? (
                <footer
                  className={`min-w-[192px] flex grow flex-col justify-end opacity-0 group-hover:opacity-100 bg-black-100 dark:bg-neutral-100 px-8 transition xl:opacity-100 ${
                    isHovered || isWideScreen ? "opacity-100" : ""
                  }`}
                >
                  <div className="mb-3 flex flex-col gap-4">
                    <button
                      type="button"
                      className="box-border flex items-center justify-center whitespace-nowrap rounded-lg font-semibold transition-bg-colors focus-visible:outline-none focus-visible:ring gap-2 text-sm w-full h-8 px-2.5 bg-primary-main text-neutral-0 hover:bg-primary-hover focus-visible:ring-secondary-focus active:bg-primary-pressed dark:focus-visible:ring-secondary-focus-dark"
                    >
                      Request Audit
                    </button>
                  </div>
                </footer>
              ) : (
                ""
              )}
            </div>
          </div>
          <button
            onClick={handleAside}
            type="button"
            className={`absolute right-0 bottom-[40px] z-50 w-fit translate-x-1/2 rounded-full bg-neutral-100 text-neutral-0 ${
              isHovered ? "opacity-1" : "opacity-0"
            } transition-opacity hover:opacity-100 group-hover:opacity-100 hidden xl:block hover:brightness-120`}
            aria-label="collapse"
          >
            <div className="p-1">
              {!isWideScreen ? (
                <FaCircleChevronRight className="text-neutral-30 text-2xl" />
              ) : (
                <FaCircleChevronLeft className="text-neutral-30 text-2xl" />
              )}
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Aside;
